<template>
  <div
    class="DocumentsList"
    v-loading="isLoading"
    element-loading-text="Pobieranie listy dokumentów..."
    element-loading-background="rgba(0, 0, 0, 0)"
  >
    <section
      v-if="!isLoading && documentsList.length === 0"
      class="DocumentsList__empty"
    >
      <i class="fa fa-eye-slash empty__icon" aria-hidden="true" />
      <label class="empty__description"> Brak dokumentów do pobrania </label>
    </section>
    <section v-else class="DocumentsList__section">
      <label class="DocumentsList__title"> Dostępne dokumenty</label>
      <div v-if="isScrollLeft" class="invisible-container" style="left: 15%">
        <div class="scrollLeft"></div>
      </div>
      <div
        ref="scrollDiv"
        class="DocumentsList__elements"
        :class="{ center: documentsListCopy.length < documentsSize }"
        v-if="!isLoading"
        @scroll="checkScroll"
      >
        <DocumentsListElement
          v-for="document in documentsListCopy"
          :key="document.uuid"
          :document="document"
        />
      </div>
      <div v-if="isScrollRight" class="invisible-container" style="right: 15%">
        <div class="scrollRight"></div>
      </div>
    </section>
  </div>
</template>

<script src="./component.js"></script>
<style src="./style.sass" lang="sass"></style>
